import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';  // Correctly import named export
import dateReducer from './slices/dateSlice';
import formReducer from './slices/formSlice';
import apiMiddleware from './middleware/apiMiddleware';

const store = configureStore({
  reducer: {
    date: dateReducer,
    form: formReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk, apiMiddleware),  // Use thunk as a named export
});

export default store;
